import { trigger, transition, style, animate } from '@angular/animations';

export const slideLeft = trigger('slideLeft', [
  // Entering element: absolute position to overlay the leaving element
  // without affecting container height during transition
  transition(':enter', [
    style({
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      opacity: 0,
      transform: 'translateX(48px)',
    }),
    animate(
      '300ms cubic-bezier(0.25, 0.8, 0.25, 1)',
      style({ opacity: 1, transform: 'translateX(0)' }),
    ),
  ]),
  // Leaving element: stays in normal flow to keep
  // container height stable throughout the transition
  transition(':leave', [
    animate(
      '300ms cubic-bezier(0.25, 0.8, 0.25, 1)',
      style({ opacity: 0, transform: 'translateX(-48px)' }),
    ),
  ]),
]);
